module.exports = __webpack_public_path__ + "static/media/6.50618ab5.jpg";